// export const server = "https://103.189.80.13:6065/api/v1";
export const server = "https://developerserver.bravishmah.com/api/v1";
export const tinyApiKey = "l73irudy8ku8bh6zz9zl796cols6924yy0lw58iyhoaaltzr";

export const DAY = 1000 * 24 * 60 * 60;

export const defaultUserImage = "";
